import initDebug from 'debug';
import { SHOW, HIDE, SET_RGPD_COOKIE, FETCH_CNIL_FAILURE, FETCH_CNIL_REQUEST, FETCH_CNIL_SUCCESS } from './actionTypes';
import TechService from '../common/services/techService';
import configService from '../../server/services/configService';
import { NAME } from './constants';

const debug = initDebug('canopy:util');

export const show = () => ({
  type: SHOW,
});

export const hide = () => ({
  type: HIDE,
});

export const setRgpdCookieState = () => ({
  type: SET_RGPD_COOKIE,
});


// Action Creators
export const fetchCnil = (headersToAdd, cookiesObj) => (dispatch, getState) => {
  const { cnilIsFetching } = getState()[NAME];

  debug('fetchCnil start cnilIsFetching', cnilIsFetching);
  if (cnilIsFetching) {
    // Do nothing, a asyc fetch is allready running
    return Promise.resolve();
  }

  dispatch({ type: FETCH_CNIL_REQUEST });
  const techService = new TechService();
  const config = configService.get();

  techService.injectEndpoint(config.backendTechUrl);
  techService.injectEndpoint(techService.getEndpoint());
  // call ws to obtain menu data
  return techService.cnil(headersToAdd, cookiesObj)
    .then((cnil) => {
      debug('fetchcnil success', cnil);
      return dispatch({
        type: FETCH_CNIL_SUCCESS,
        payload: cnil,
      });
    })
    .catch((err) => {
      debug('fetchcnil fail', err);
      dispatch({ type: FETCH_CNIL_FAILURE, error: err });
    });
};
